import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, NavLink, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { MessageBelow, MessageAbove } from "./components/App-Contents.js";
import { About, AboutStAntony } from "./components/About.js";
import Mary from "./components/uMary.js";
import Sebastain from "./components/uSebastain.js";
import Alphonsa from "./components/uAlphonsa.js";
import Antony from "./components/uAntony.js";
import Little from "./components/uLittle.js";
import Joseph from "./components/uJoseph.js";
import Thomas from "./components/uThomas.js";
import Francis from "./components/uFrancis.js";
import { Prath, Kendra } from "./components/Admin.js";
import Catechism from "./components/oCatechism.js";
import KCYM from "./components/okcym.js";
import CLC from "./components/oclc.js";
import Mathrevedi from "./components/omathrevedi.js";
import Altar from "./components/oaltar.js";
import VayojanaSagam from "./components/ovayojanasagam.js";
import Choir from "./components/ochoir.js";
import Contac from "./components/Contact.js";
import { Gallery } from "./components/Gallery.js";
import "./app.css";

/* ---------------- POPUP STYLES ---------------- */
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    textAlign: "center",
    width: "320px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
  },
  button: {
    marginTop: "15px",
    padding: "8px 18px",
    border: "none",
    background: "#8B0000",
    color: "#fff",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

/* ---------------- HOME ---------------- */

function Home() {
  return (
    <div>
      <MessageAbove />
      <MessageBelow />
    </div>
  );
}

/* ---------------- APP ---------------- */

function App() {

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const [visible, setVisible] = useState(false);

  const toggleDropdown = (dropdownName) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [dropdownName]: !prev[dropdownName],
    }));
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) setVisible(true);
      else setVisible(false);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* Popup logic */

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("constructionPopup");

    if (!seen) {
      setShowPopup(true);
      sessionStorage.setItem("constructionPopup", "true");
    }
  }, []);

  return (
    <div>

      {/* -------- POPUP -------- */}

      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <h2>🚧 Website Under Construction</h2>
            <p>
              This website is currently in building stage.<br />
              Thank you for your patience. God Bless You 🙏
            </p>
            <button
              style={styles.button}
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* -------- ROUTER -------- */}

      <Router>
        <ScrollToTop />

        <header>
          {/* MENU BUTTON */}
          <div
            className="menu-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </div>

          <nav className={sidebarOpen ? "sidebar open" : "sidebar"}>
            <ol>

              <li>
                <NavLink to="/" className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } onClick={() => setSidebarOpen(false)}>
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink to="/history" className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } onClick={() => setSidebarOpen(false)}>
                  History
                </NavLink>
              </li>

              <li className={`dropdown ${openDropdowns['familyUnits'] ? 'open' : ''}`}>
                <span className="dropdown-title" onClick={() => toggleDropdown('familyUnits')}>Family Units</span>
                <ul className="dropdown-menu">
                  <li><NavLink to="/familyunits/stmary" onClick={() => setSidebarOpen(false)}>St.Mary</NavLink></li>
                  <li><NavLink to="/familyunits/stsebastain" onClick={() => setSidebarOpen(false)}>St.Sebastain</NavLink></li>
                  <li><NavLink to="/familyunits/stalphonsa" onClick={() => setSidebarOpen(false)}>St.Alphonsa</NavLink></li>
                  <li><NavLink to="/familyunits/stantony" onClick={() => setSidebarOpen(false)}>St.Antony</NavLink></li>
                  <li><NavLink to="/familyunits/stlittleflower" onClick={() => setSidebarOpen(false)}>St.Little Flower</NavLink></li>
                  <li><NavLink to="/familyunits/stjoseph" onClick={() => setSidebarOpen(false)}>St.Joseph</NavLink></li>
                  <li><NavLink to="/familyunits/stthomas" onClick={() => setSidebarOpen(false)}>St.Thomas</NavLink></li>
                  <li><NavLink to="/familyunits/stfrancisassissi" onClick={() => setSidebarOpen(false)}>St.Francis Assissi</NavLink></li>
                </ul>
              </li>
              <li className={`dropdown ${openDropdowns['administration'] ? 'open' : ''}`}>
                <span className="dropdown-title" onClick={() => toggleDropdown('administration')}>Administration</span>
                <ul className="dropdown-menu">
                  <li><NavLink to="/administration/prathinidyogam" onClick={() => setSidebarOpen(false)}>Prathinidyogam</NavLink></li>
                  <li><NavLink to="/administration/kendrasamathi" onClick={() => setSidebarOpen(false)}>Kendrasamathi</NavLink></li>
                </ul>
              </li>

              <li className={`dropdown ${openDropdowns['organisations'] ? 'open' : ''}`}>
                <span className="dropdown-title" onClick={() => toggleDropdown('organisations')}>Organisations</span>
                <ul className="dropdown-menu">
                  <li><NavLink to="/organisations/catechism" onClick={() => setSidebarOpen(false)}>Catechism</NavLink></li>
                  <li><NavLink to="/organisations/kcym" onClick={() => setSidebarOpen(false)}>K.C.Y.M</NavLink></li>
                  <li><NavLink to="/organisations/clc" onClick={() => setSidebarOpen(false)}>C.L.C</NavLink></li>
                  <li><NavLink to="/organisations/vayojanasagam" onClick={() => setSidebarOpen(false)}>VayojanaSagam</NavLink></li>
                  <li><NavLink to="/organisations/mathrevedi" onClick={() => setSidebarOpen(false)}>Mathrevedi</NavLink></li>
                  <li><NavLink to="/organisations/altarboys" onClick={() => setSidebarOpen(false)}>Altar Boys</NavLink></li>
                  <li><NavLink to="/organisations/choir" onClick={() => setSidebarOpen(false)}>Church Choir</NavLink></li>
                </ul>
              </li>

              <li>
                <NavLink to="/contact" className={({ isActive }) =>
                  isActive ? "active-link" : "link"
                } onClick={() => setSidebarOpen(false)}>
                  Contact
                </NavLink>
              </li>
            </ol>
          </nav>

          <h1>ST. ANTONY'S CHURCH</h1>

          <div className="locationdetails">
            <h4>
              VASUPURAM | MATTATHURKUNNU P.O. | PIN: 680684
            </h4>
            <h3>A SYRO MALABAR CHURCH UNDER DIOCESE OF IRINJALAKUDA</h3>
          </div>
        </header>

        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/history" element={<About />} />
            <Route path="/history/stantonys" element={<AboutStAntony />} />
            <Route path="/familyunits" element={<Navigate to="/familyunits/stmary" replace />} />
            <Route path="/familyunits/stmary" element={<Mary />} />
            <Route path="/familyunits/stsebastain" element={<Sebastain />} />
            <Route path="/familyunits/stalphonsa" element={<Alphonsa />} />
            <Route path="/familyunits/stantony" element={<Antony />} />
            <Route path="/familyunits/stlittleflower" element={<Little />} />
            <Route path="/familyunits/stjoseph" element={<Joseph />} />
            <Route path="/familyunits/stthomas" element={<Thomas />} />
            <Route path="/familyunits/stfrancisassissi" element={<Francis />} />
            <Route path="/administration" element={<Navigate to="/administration/prathinidyogam" replace />} />
            <Route path="/administration/prathinidyogam" element={<Prath />} />
            <Route path="/administration/kendrasamathi" element={<Kendra />} />
            <Route path="/organisations" element={<Navigate to="/organisations/catechism" replace />} />
            <Route path="/organisations/catechism" element={<Catechism />} />
            <Route path="/organisations/kcym" element={<KCYM />} />
            <Route path="/organisations/clc" element={<CLC />} />
            <Route path="/organisations/choir" element={<Choir />} />
            <Route path="/organisations/altarboys" element={<Altar />} />
            <Route path="/organisations/mathrevedi" element={<Mathrevedi />} />
            <Route path="/organisations/vayojanasagam" element={<VayojanaSagam />} />
            <Route path="/contact" element={<Contac />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </div>

        {visible && (
          <img
            src="/images/top.png"
            alt="Scroll to top"
            className="scrollImageBtn"
            onClick={scrollToTop}
          />
        )}

        <div className="copyright">
          <div class="social-icons">
            <a href="https://www.facebook.com/stantonysvasupuram" target="_blank" rel="noopener noreferrer">
              <img src="/images/ColorFacebook.png" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/stantonysvasupuram/" target="_blank" rel="noopener noreferrer">
              <img src="/images/ColorYoutube.png" alt="Instagram" />
            </a>
          </div>
          <span>©️ 2025 St. Antony's Church Vasupuram Media Team</span>
        </div>

      </Router>
    </div>
  );
}

export default App;